export default __webpack_public_path__ + "static/media/logo-yellow.c6d88c6f.svg";